/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SignUpInviteSent/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import Button from 'DesignSystem/Button/index'
import EnsureUrl from 'DesignSystem/EnsureUrl/react'
import Info from 'DesignSystem/Info/index'
import OnboardingEmail from 'DesignSystem/Images/OnboardingEmail/index'
import OnboardingMailMask from 'DesignSystem/Svgs/OnboardingMailMask/index'
import React from 'react'
import SubTitle from 'DesignSystem/SubTitle/index'
import TitleLarge from 'DesignSystem/TitleLarge/index'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'
import useIsMedia from 'Simple/hooks/useIsMedia'
import viewPath from './viewPath.js'
import { animated, useSpring } from "@react-spring/web"



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function SignUpInviteSent({
  children,
  viewPath = "/App/Auth/SignUpInviteSent"
  
}) {
  let isBefore = useIsBefore()
  let isMedia = useIsMedia()
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsGreen700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.700'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
let animatedVertical31 = useSpring({
"config": {
friction: 10,
tension: 170,
},
"delay": 350,
"from": {"top": "-120px"},
"to": {"top": isBefore ? "0px" : "-120px"},
})
  return (<React.Fragment
>
<EnsureUrl
  viewPath={`${viewPath}/EnsureUrl`}
/>
<div
  data-testid="SignUpInviteSent.Vertical"
  data-view-path={viewPath}
 style={{'--w-1-Z14jGxw': isBefore ? "50%" : "100%"}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="SignUpInviteSent.Vertical:1"
  data-view-path={viewPath}
 style={{'--bc-3-Z14jGxw': dtColorsWhite,'--bblr-4-Z14jGxw': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--bbrr-5-Z14jGxw': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--btlr-6-Z14jGxw': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--btrr-7-Z14jGxw': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pl-8-Z14jGxw': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pb-9-Z14jGxw': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-10-Z14jGxw': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--sc-11-Z14jGxw': dtColorsGreen700,'--o-13-Z14jGxw': isBefore ? 0 : 1,'--tx-12-Z14jGxw': isBefore ? "100px" : "0px",'--w-1-Z14jGxw': isMedia.mobile ? "360px" : "500px",'--h-2-Z14jGxw': isMedia.mobile ? "430px" : "420px"}}
 className={`views-block ${styles.Vertical1}`}
>
<div
  data-testid="SignUpInviteSent.Vertical:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical2}`}
>
<OnboardingMailMask
  viewPath={`${viewPath}/OnboardingMailMask`}
 width={200}
 height="auto"
/>
</div>
<animated.div
  data-testid="SignUpInviteSent.Vertical:3"
  data-view-path={viewPath}
 style={{"--t-14-Z14jGxw": animatedVertical31.top,'--o-13-Z14jGxw': isBefore ? 0 : 1}}
 className={`views-block ${styles.Vertical3}`}
>
<OnboardingEmail
  viewPath={`${viewPath}/OnboardingEmail`}
 width={200}
 height="auto"
/>
</animated.div>
<div
  data-testid="SignUpInviteSent.Vertical:4"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical4}`}
/>
<div
  data-testid="SignUpInviteSent.Vertical:5"
  data-view-path={viewPath}
 style={{'--pl-8-Z14jGxw': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pr-10-Z14jGxw': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Vertical5}`}
>
<TitleLarge
  viewPath={`${viewPath}/TitleLarge`}
 text="Check your email!"
/>
<SubTitle
  viewPath={`${viewPath}/SubTitle`}
 marginRight={dtSpaceL}
 marginLeft={dtSpaceL}
 textAlign="center"
 marginTop={dtSpaceS}
 lineHeight="20px"
 text="Click on the link in the email to verify your account"
/>
<Button
  viewPath={`${viewPath}/Button`}
 marginTop={isMedia.mobile ? dtSpaceL : "48px"}
 text="Send Again"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../SignUp'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../SignUp'))}
/>
<Info
  viewPath={`${viewPath}/Info`}
 marginTop={dtSpaceM}
 text="No email? Check your spam folder."
 fontSize={12}
 whiteSpace="wrap"
 textAlign="center"
/>
<Info
  viewPath={`${viewPath}/Info`}
 marginTop={dtSpaceS}
 marginLeft={dtSpaceS}
 marginRight={dtSpaceS}
 text="If you do not receive an email please contact your clinic and confirm they have the correct email and cell phone for your account."
 fontSize={12}
 whiteSpace="wrap"
 textAlign="center"
/>
</div>
</div>
</div>
{children}
</React.Fragment>)
}